import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import 'jquery.formstyler';

$(() => {
	svg4everybody();
});
$(document).ready(function(){
	//иницилизация стилей, для инпутов
	$('input, select').styler({
		selectSmartPositioning: false
	});
	// $('input:checkbox').attr('disabled', true)
	// 	/* обновляем состояние псевдочекбокса */
	// 	.trigger('refresh');
	//табы поиска (в лоб, если время будет оптимизировать)
	$('#search-tab__link_tire').on("click", function () {
		if($("#search-tab__link_disk").hasClass('search-tab__link_active')) {
			$('#search-tab__link_disk').removeClass('search-tab__link_active');
			$(this).addClass('search-tab__link_active');
			$('#search-tab__image').addClass('search-tab__image_tire');
			$('#search-tab__image').removeClass('search-tab__image_disk');

			$('.form-disk').slideUp();
			$('.form-tire').slideDown();
		}
	});
	$('#search-tab__link_disk').on("click", function () {
		if($("#search-tab__link_tire").hasClass('search-tab__link_active')) {
			$('#search-tab__link_tire').removeClass('search-tab__link_active');
			$(this).addClass('search-tab__link_active');
			$('#search-tab__image').addClass('search-tab__image_disk');
			$('#search-tab__image').removeClass('search-tab__image_tire');

			$('.form-disk').slideDown();
			$('.form-tire').slideUp();
		}
	});
	//развернуть поиск
	$('.turn__item').on("click", function () {
		$(this).toggleClass('turn__item_active');
		$('#search').slideToggle();
		$(this).hasClass("turn__item_active") ? $(this).html("Свернуть поиск") : $(this).html("Развернуть поиск");
		$('.header').toggleClass('sizes');

	});
	//развернуть доп поля
	$('#check').on("click", function () {
		$('#check_toggle').slideToggle();
	});
	$('#check_toggle').toggle(false);
	if($('#check .jq-checkbox').hasClass('checked')){
		$('#check_toggle').slideDown();
	}

	//сбросить форму

	$('.refresh-search').click(function(e) {
		e.preventDefault();
		/* делаем чекбокс неактивным */
		$(this).parent().parent().find("select").each(function() {
			$(this).find('option:first').prop("selected", true).trigger('refresh');
		});

	});

	// табы бренд
	$(function() {
		$('.tabs .tabs__link').click(function(e) {
			var i=$(this).data('id');
			e.preventDefault();
			$('.tabs .tabs__link').removeClass('tabs__link_active');
			$(this).addClass('tabs__link_active');
			$('.brends > div').hide();
			$('.d'+i).fadeIn();
		});
	});
	//фильтр
	$(function() {
		$('.filtr__link_icon').click(function(e) {
			e.preventDefault();
			if ($(this).hasClass("filtr__link_active"))
				$(this).toggleClass('filtr__link_icon_on');
		});

		$('.filtr .filtr__link').click(function(e) {
			e.preventDefault();
			$('.filtr .filtr__link').removeClass('filtr__link_active');
			$(this).addClass('filtr__link_active');
		});
	});

	//чек доставки
	$(function() {
		$('.delivery__item').click(function(e) {
			e.preventDefault();
			$('.delivery__item').removeClass('delivery__item_active');
			$(this).addClass('delivery__item_active');
		});
	});
	//чек выбора оплаты
	$(function() {
		$('.pay__item').click(function(e) {
			e.preventDefault();
			$('.pay__item').removeClass('pay__item_active');
			$(this).addClass('pay__item_active');
		});
	});
	//моб меню
	$(function() {
		$('.top-header__item_mob').click(function(e) {
			$('.menu-top').slideToggle();
		});
	});
	//ховер на тригеры
	// $(function() {
	// 	$('.trigers__item').hover(function() {
	// 		$(this).animate({
	// 			backgroundSize: "120%"
	// 		}, 600 );
	// 	});
	// });
	$(".trigers__item").hover(function(){
		$(this).animate({
			backgroundSize: "110%"
		}, 100 );
	});
	$(".trigers__item").mouseout(function(){
		$(this).animate({
			backgroundSize: "100%"
		}, 100 );
	});

});



// WEBPACK FOOTER //
// ./app/scripts/app.js